<template>
    <slot data-bs-toggle="modal" :data-bs-target="'#BatchExtend' + TbtnId"></slot>
    <div
      class="modal fade"
      :id="'BatchExtend' + TbtnId"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
      style="background: rgba(0, 0, 0, 0.8)"
    >
      <div class="modal-dialog modal-ext modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              일괄 처리
            </h5>
          </div>

  <div  class="modal-body">
          <template v-if="this.$root.guiPerm == 'ROOT' && students"
                    >학교ID&nbsp;:&nbsp;
                    <select
                      class="hidtype" style="padding:4px 16px;"
                      v-model="students.school_ids"
                    >
                      <option value="MyPath">MyPath</option>                      
                      <option value="kchild408">kchild408</option>
                      <option value="kchild139">kchild139</option>
                    </select>
                  </template>


            <div class="flex_center" style="text-align: center">
              <button
                class="btn btn-danger"
                data-bs-dismiss="modal"
                @click="set_pay_date()"
              >
                결제일 변경하기
              </button>
              <button
              class="btn btn-info"
              v-on:click="requestsetup(Tsub)"
            >
              대행
            </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import axios from "axios";
  export default {
    name: "EnddateMultiple",
    props: {
      students: Array,
      btnId: String,
    },

    data: function () {
      return {
        TbtnId: this.btnId || Math.random().toString().substr(2, 5),
        levelRequest: [],
      };
    },
    methods: {
      set_pay_date() {
        var requests = [];
        var new_end_date = prompt("새 결제일을 입력하세요. 예: 2022-04-05");
      if (!new_end_date) return;
        this.students.forEach((student, i) => {
          console.log(student)
          requests.push(
            new Promise((resolve) => {

              axios
                .patch("/subscriptions/" + student.id, {
                  pay_date: new_end_date,
                })
                .then((response) => {
                  if (response.data.error) {
                    $.notify(
                      {
                        // options
                        message:
                          (i + 1) +
                          "번째 " +
                          student.orderId +
                          " 변경실패: " +
                          response.data.error,
                      },
                      {
                        // settings
                        type: "danger",
                        z_index: 9999,
                      }
                    );
                  } else {
                    $.notify(
                      {
                        // options
                        message:
                        (i + 1) +
                          "번째 " +
                          student.orderId +
                          (response.data.status == "requested"
                            ? " 변경 요청되었습니다. "
                            : " 변경되었습니다."),
                      },
                      {
                        // settings
                        type: "success",
                        z_index: 9999,
                      }
                    );
                  }
                });
            })
          );
        });
      },
      requestsetup() {
        if (!this.students.school_ids) {
          $.notify({
            // options
            message: '부여할 학교ID를 선택하셔야 합니다. '
          }, {
            // settings
            type: 'danger',
            z_index: 9999
          });
          return;
        }
        var requests = [];
        this.students.forEach((student, i) => {
          console.log(student)
          requests.push(
            new Promise((resolve) => {

              axios
              .patch("/subscriptions/" + student.id, {
                usid: "8080",
                school_id: this.students.school_ids,
                state: "ACTIVE",
              })
                .then((response) => {
                  if (response.data.error) {
                    $.notify(
                      {
                        // options
                        message:
                          (i + 1) +
                          "번째 " +
                          student.orderId +
                          " 변경실패: " +
                          response.data.error,
                      },
                      {
                        // settings
                        type: "danger",
                        z_index: 9999,
                      }
                    );
                  } else {
                    $.notify(
                      {
                        // options
                        message:
                        (i + 1) +
                          "번째 " +
                          student.orderId +
                          (response.data.status == "requested"
                            ? " 변경 요청되었습니다. "
                            : " 변경되었습니다."),
                      },
                      {
                        // settings
                        type: "success",
                        z_index: 9999,
                      }
                    );
                  }
                });
            })
          );
        });
      },
    },
  };
  </script>

  <style></style>
